import { render, staticRenderFns } from "./VendorsForm.vue?vue&type=template&id=c76c9198&"
import script from "./VendorsForm.vue?vue&type=script&lang=js&"
export * from "./VendorsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports